import { NumberBox } from "./numberBox";
import { JackpotWheel } from "./JackpotWheel";

// import { createMovieClip } from "../../globalFunctions";

// import { GameData } from "../../gamestate/gameData";
import { displayJackpotBGCounter } from "../jackpotGlobalFunctions";
import { createMovieClip } from "../../functions/Functions_General";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { convertCreditsFromServerToClient } from "../../datastructures/Credits";

export class JackpotWheelGame {
  private parent: PIXI.Container;
  private bgParent: PIXI.Container;
  private jackpotGameContainer: PIXI.Container;
  private wheelContainer: PIXI.Container;
  // private closeBtnContainer:PIXI.Container;
  private labelsContainer: PIXI.Container;
  private jackpotBG: PIXI.Container;

  private jackpotBlackBGIn: PIXI.tween.Tween;
  private jackpotBlackBGOut: PIXI.tween.Tween;
  private jackpotAnimatedBGLightRight: PIXI.Sprite;
  private jackpotAnimatedBGLightLeft: PIXI.Sprite;
  private jackWheelBackLightAnimation: PIXI.Sprite;
  private jackWheelBackLightAnimation2: PIXI.Sprite;
  private jackWheelBackLightAnimationTween: PIXI.tween.Tween;
  private jackWheelBackLightAnimation2Tween: PIXI.tween.Tween;
  private pointerDefaultAnimation: PIXI.extras.AnimatedSprite;
  private animationTimer: PIXI.tween.Tween;
  private textureJackpotResult1: PIXI.Texture;
  private jackpotResultDisplay: PIXI.Sprite;
  private activeGameData: CommonData;

  private megaBox: NumberBox;
  private midiBox: NumberBox;
  private miniBox: NumberBox;
  private wheel: JackpotWheel;
  private numberBoxList: Array<NumberBox>;
  private jackpotBlackBG: PIXI.Graphics;

  private tweenSlideRight: PIXI.tween.Tween;
  private tweenSlideCenter: PIXI.tween.Tween;
  private isCentered: boolean;
  private isPortraitMode: boolean;

  constructor(parent: PIXI.Container, activeGameData: any) {
    this.bgParent = new PIXI.Container();
    parent.addChild(this.bgParent);
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);

    this.isCentered = false;
    this.isPortraitMode = false;
    this.activeGameData = activeGameData;
    this.jackpotGameContainer = new PIXI.Container();
    this.jackpotBG = new PIXI.Container();

    this.wheelContainer = new PIXI.Container();
    // this.closeBtnContainer=new PIXI.Container();

    this.labelsContainer = new PIXI.Container();
    this.jackpotGameContainer.addChild(this.labelsContainer);

    this.jackpotGameContainer.addChild(this.wheelContainer);
    // this.jackpotGameContainer.addChild(this.closeBtnContainer);

    //BG ITEMS
    this.jackpotBlackBG = new PIXI.Graphics();
    this.jackpotBlackBGIn = PIXI.tweenManager.createTween(this.jackpotBlackBG);
    this.jackpotBlackBGOut = PIXI.tweenManager.createTween(this.jackpotBlackBG);
    this.jackpotAnimatedBGLightRight = new PIXI.Sprite(
      PIXI.Texture.fromImage("jackpotlightBG.png")
    );
    this.jackpotAnimatedBGLightLeft = new PIXI.Sprite(
      PIXI.Texture.fromImage("jackpotlightBG.png")
    );
    this.jackpotAnimatedBGLightRight.blendMode = PIXI.BLEND_MODES.ADD;
    this.jackpotAnimatedBGLightLeft.blendMode = PIXI.BLEND_MODES.ADD;
    // this.particleTexture=PIXI.Texture.fromImage("lightWheel.png");

    //spinning Effect around wheel
    this.jackWheelBackLightAnimation = new PIXI.Sprite(
      PIXI.Texture.fromImage("jackpotLightSwipe.png")
    );
    this.jackWheelBackLightAnimation2 = new PIXI.Sprite(
      PIXI.Texture.fromImage("jackpotLightSwipe.png")
    );
    this.jackWheelBackLightAnimationTween = PIXI.tweenManager.createTween(
      this.jackWheelBackLightAnimation
    );
    this.jackWheelBackLightAnimation2Tween = PIXI.tweenManager.createTween(
      this.jackWheelBackLightAnimation2
    );
    this.jackWheelBackLightAnimation2.blendMode = PIXI.BLEND_MODES.ADD;
    this.jackWheelBackLightAnimation.blendMode = PIXI.BLEND_MODES.ADD;
    //GAME VISUALFX ELEMS
    // this.orbDefaultAnimation=createMovieClip("orbdefault",0,26);
    this.pointerDefaultAnimation = createMovieClip("pointer", 0, 26);
    this.pointerDefaultAnimation.animationSpeed = 0.4;

    this.animationTimer = PIXI.tweenManager.createTween(
      this.jackWheelBackLightAnimation
    );
    this.textureJackpotResult1 = PIXI.Texture.fromImage(
      "minipotText_display.png"
    );
    // this.textureJackpotResult2=PIXI.Texture.fromImage('midipotTextdisplay.png');
    // this.textureJackpotResult3=PIXI.Texture.fromImage('megaJackpotTextdisplay.png');
    this.jackpotResultDisplay = new PIXI.Sprite(this.textureJackpotResult1);

    this.megaBox = new NumberBox(
      this.activeGameData.MegaPot.getCurrent(),
      this.activeGameData.currency,
      "MEGA JACKPOT",
      3
    );
    this.midiBox = new NumberBox(
      this.activeGameData.MidiPot.getCurrent(),
      this.activeGameData.currency,
      "MIDI JACKPOT",
      2
    );
    this.miniBox = new NumberBox(
      this.activeGameData.MiniPot.getCurrent(),
      this.activeGameData.currency,
      "MINI JACKPOT",
      1
    );

    if (this.activeGameData.isMobile) {
      this.megaBox.setMobileAnimationDuration();
      this.midiBox.setMobileAnimationDuration();
      this.miniBox.setMobileAnimationDuration();
    }

    this.numberBoxList = [this.miniBox, this.midiBox, this.megaBox];
    //call fn to place
    this.createBgElem();
    this.createGameElem();
    this.createSlideTween();

    this.bgParent.addChild(this.jackpotBG);
    this.parent.addChild(this.jackpotGameContainer);
    this.parent.x = 0;
    this.parent.y = 0;
    this.parent.alpha = 1;
  }

  private createBgElem = (): void => {
    //createBlackBG

    this.jackpotBlackBG.beginFill(0x000000);
    this.jackpotBlackBG.drawRect(
      0,
      0,
      this.activeGameData.size[0],
      this.activeGameData.size[1]
    );
    this.jackpotBlackBG.endFill();
    this.jackpotBlackBG.pivot.set(this.jackpotBlackBG.width / 2, 0);
    this.jackpotBlackBG.x = this.jackpotBlackBG.width / 2;
    this.jackpotBlackBG.y = 0; //this.jackpotBlackBG.height/2;
    // this.jackpotBlackBG.width=1//this.activeGameData.size[0]*2;
    this.jackpotBlackBG.height = this.activeGameData.size[1];
    this.jackpotBG.addChild(this.jackpotBlackBG);

    this.jackpotBlackBG.alpha = 0;

    this.jackpotBlackBGIn.from({ alpha: 0 }).to({ alpha: 0.8 });
    this.jackpotBlackBGIn.time = 2000;
    this.jackpotBlackBGIn.easing = PIXI.tween.Easing.linear();

    this.jackpotBlackBGOut.from({ alpha: 0.8 }).to({ alpha: 0 });
    this.jackpotBlackBGOut.time = 2000;
    this.jackpotBlackBGOut.easing = PIXI.tween.Easing.linear();
    this.wheelContainer.addChild(this.jackpotAnimatedBGLightRight);
    this.jackpotAnimatedBGLightRight.x = this.activeGameData.size[0] / 2;
    this.jackpotAnimatedBGLightRight.y = 0;
    this.jackpotAnimatedBGLightRight.alpha = 0;

    this.wheelContainer.addChild(this.jackpotAnimatedBGLightLeft);
    this.jackpotAnimatedBGLightLeft.scale.set(-1, 1);
    this.jackpotAnimatedBGLightLeft.x = this.activeGameData.size[0] / 2;
    this.jackpotAnimatedBGLightLeft.y = 0;
    this.jackpotAnimatedBGLightLeft.alpha = 0;

    ////animated spinning aura
    this.jackWheelBackLightAnimation.anchor.set(0.5);
    this.jackWheelBackLightAnimation.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );
    // this.jackWheelBackLightAnimation.scale.set(3.5)
    this.wheelContainer.addChild(this.jackWheelBackLightAnimation);

    this.jackWheelBackLightAnimation2.anchor.set(0.5);
    this.jackWheelBackLightAnimation2.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );
    // this.jackWheelBackLightAnimation2.scale.set(3.5)
    this.wheelContainer.addChild(this.jackWheelBackLightAnimation2);

    this.jackWheelBackLightAnimationTween
      .from({
        rotation: this.jackWheelBackLightAnimation.rotation,
        scale: { x: 4, y: 4 },
      })
      .to({
        rotation:
          this.jackWheelBackLightAnimation.rotation - (360 * Math.PI) / 180,
        scale: { x: 4, y: 4 },
      });
    this.jackWheelBackLightAnimationTween.time = 8000;
    this.jackWheelBackLightAnimationTween.easing = PIXI.tween.Easing.linear();
    this.jackWheelBackLightAnimationTween.loop = true;

    this.jackWheelBackLightAnimation2Tween
      .from({ scale: { x: 1, y: 1 }, alpha: 1 })
      .to({ scale: { x: 3, y: 3 }, alpha: 0 });
    this.jackWheelBackLightAnimation2Tween.time = 2000;
    this.jackWheelBackLightAnimation2Tween.easing = PIXI.tween.Easing.linear();
    this.jackWheelBackLightAnimation2Tween.loop = true;

    this.jackWheelBackLightAnimation.alpha = 0;
    this.jackWheelBackLightAnimation2.alpha = 0;

    //
  };
  private createSlideTween = (): void => {
    this.tweenSlideRight = PIXI.tweenManager.createTween(this.parent);
    this.tweenSlideRight.from({ x: 0 }).to({ x: 320 });
    this.tweenSlideRight.time = 0;
    this.tweenSlideRight.loop = false;
    this.tweenSlideRight.easing = PIXI.tween.Easing.outBack();
    this.tweenSlideRight.stop();

    this.tweenSlideCenter = PIXI.tweenManager.createTween(this.parent);
    this.tweenSlideCenter.from({ x: 200 }).to({ x: 0 });
    this.tweenSlideCenter.time = 2000;
    this.tweenSlideCenter.loop = false;
    this.tweenSlideCenter.easing = PIXI.tween.Easing.outExpo();
    this.tweenSlideCenter.stop();
  };

  private setLabelTodefaultPos = (): void => {
    //default pos labels
    this.megaBox.setPosition(32, this.activeGameData.size[1] / 2 - 200);
    this.midiBox.setPosition(32, this.activeGameData.size[1] / 2);
    this.miniBox.setPosition(32, this.activeGameData.size[1] / 2 + 200);
  };
  private createGameElem = (): void => {
    // this.megaBox.frame.x=100

    this.megaBox.setParent(this.labelsContainer);
    this.midiBox.setParent(this.labelsContainer);
    this.miniBox.setParent(this.labelsContainer);

    this.setLabelTodefaultPos();

    this.wheel = new JackpotWheel(this.activeGameData);
    this.wheel.setPositionAndParent(this.wheelContainer, 0, 0);

    // this.wheel.winScoreDisplay.scoreContainerTweenOut.on('start',function(self:JackpotWheelGame){
    //     self.endJackpotWheel()
    // }.bind(this.wheel.winScoreDisplay.scoreContainerTweenOut,this));

    this.jackpotResultDisplay.y = this.activeGameData.size[1] / 2 + 50;
    this.jackpotResultDisplay.alpha = 1;
    this.jackpotResultDisplay.anchor.set(0.5);
    this.jackpotResultDisplay.x = this.activeGameData.size[0] / 2;

    // this.megaBox.label.x=this.megaBox.frame.width-this.megaBox.label.width-20;
    // this.midiBox.label.x=20-this.midiBox.frame.width/2;
    // this.miniBox.label.x=20-this.miniBox.frame.width/2;
    //

    //Total duration of animation 10 sec then start close
    this.animationTimer.to({ alpha: this.jackWheelBackLightAnimation.alpha });
    this.animationTimer.time = 10;
    this.animationTimer.easing = PIXI.tween.Easing.linear();
  };

  private setStartAnimation() {
    this.megaBox.startInAnimation();
    this.midiBox.startInAnimation();
    this.miniBox.startInAnimation();
    this.wheel.startInAnimation();
    this.jackpotBlackBGIn.reset();
    this.jackpotBlackBGIn.start(); //bg animation
    this.jackpotAnimatedBGLightLeft.alpha = 1;
    this.jackpotAnimatedBGLightRight.alpha = 1;
    this.jackWheelBackLightAnimation.alpha = 1;
    this.jackWheelBackLightAnimation2.alpha = 1;
    if (this.activeGameData.isMobile == false) {
      this.jackWheelBackLightAnimation2Tween.start();
      this.jackWheelBackLightAnimationTween.start();
    }
  }

  public stop = (): void => {
    //hide

    this.jackpotBlackBG.interactive = false;
    this.jackpotBG.alpha = 0;
    this.jackpotBlackBGOut.stop();
    this.jackpotAnimatedBGLightLeft.alpha = 0;
    this.jackpotAnimatedBGLightRight.alpha = 0;
    this.jackWheelBackLightAnimation.alpha = 0;
    this.jackWheelBackLightAnimation2.alpha = 0;
    this.jackWheelBackLightAnimationTween.stop();
    this.jackWheelBackLightAnimation2Tween.stop();

    this.megaBox.stop();
    this.midiBox.stop();
    this.miniBox.stop();
    this.wheel.stop();
    displayJackpotBGCounter(this.activeGameData, true);
    // this.wheel.winScoreDisplay.setVisibile(false);
    // console.log('FORCE STOP JACKPOT')

    this.jackpotBlackBGIn.stop();
    this.jackpotBlackBGOut.stop();
    this.jackWheelBackLightAnimationTween.stop();
    this.jackWheelBackLightAnimation2Tween.stop();
    this.animationTimer.stop();
    this.tweenSlideRight.stop();
    this.tweenSlideCenter.stop();
  };

  private setEndAnimation = (): void => {
    this.megaBox.startOutAnimation();
    this.midiBox.startOutAnimation();
    this.miniBox.startOutAnimation();

    this.wheel.startOutAnimation();
    this.jackpotBlackBG.alpha = 0.8;

    this.jackpotBlackBGOut.reset();
    this.jackpotBlackBGOut.start();
    this.jackpotAnimatedBGLightLeft.alpha = 0;
    this.jackpotAnimatedBGLightRight.alpha = 0;
    this.jackWheelBackLightAnimation.alpha = 0;
    this.jackWheelBackLightAnimation2.alpha = 0;

    this.jackWheelBackLightAnimationTween.stop();
    this.jackWheelBackLightAnimation2Tween.stop();
    // this.wheel.winScoreDisplay.displayOut();
    this.wheel.getWinScreen().setVisibile(false);

    // this.wheel.displayScore();
    displayJackpotBGCounter(this.activeGameData, true);
  };
  public setWheelWinAndSpin(
    winIndex: number //with result
  ) {
    this.jackpotBlackBG.interactive = true;
    this.jackpotBG.alpha = 0.8;
    this.wheel.setWheelWin(winIndex);
    this.wheel.getWinScreen().setScoreContainertTweenOutReset();
  }

  public setLabelValue = (): void => {
    //updates new values
    let sortedData = [];

    //-debug

    //--

    let data = this.activeGameData.jackpotContext.jackpotValues;

    for (let i = 0; i < data.length; i++) {
      let lvl = data[i].jackpotLevel;
      switch (lvl) {
        case 1:
          sortedData[0] = data[i];
          break;
        case 2:
          sortedData[1] = data[i];
          break;

        case 3:
          sortedData[2] = data[i];
          break;

        default:
          break;
      }
    }
    this.setValueAndLog(this.miniBox, sortedData[0]?.currentValue.amount); //mini
    this.setValueAndLog(this.midiBox, sortedData[1]?.currentValue.amount); //midi
    this.setValueAndLog(this.megaBox, sortedData[2]?.currentValue.amount); //mega
  };

  private setValueAndLog(box: NumberBox, currentValue: string | number) {
    if (
      currentValue !== undefined &&
      currentValue !== null &&
      typeof currentValue === "number"
    ) {
      box.setValue(convertCreditsFromServerToClient(currentValue));
    } else {
      let errorText = this.activeGameData.gameTextGeneral.Unavailable;
      box.setValue(errorText);
    }
  }

  public setMask = (mask: PIXI.Graphics): void => {
    this.parent.mask = mask;
  };

  public setHighlight = (bool: boolean, boxIndex: number): void => {
    // console.log(bool,boxIndex)
    this.numberBoxList[boxIndex].setBoxHighlight(bool);
  };

  public setJackpotWheelCentered(bool: boolean) {
    this.isCentered = bool;
    this.isCentered;
    if (bool) {
      this.setWheelCenter();
      this.labelsContainer.alpha = 0;
      // this.setPortraitMode(false);
    } else {
      this.setWheelRight();
      this.labelsContainer.alpha = 1;
    }

    //-- adjust Positions
    this.setPortraitMode(this.isPortraitMode);
  }
  private setWheelCenter = (): void => {
    this.tweenSlideCenter.reset();
    this.tweenSlideCenter.start();
  };
  private setWheelRight = (): void => {
    this.tweenSlideRight.reset();
    this.tweenSlideRight.start();
  };
  public getBlackBG = (): PIXI.Graphics => {
    return this.jackpotBlackBG;
  };
  public setBGWidth = (canvasWidth: number): void => {
    this.jackpotBlackBG.width =
      (canvasWidth * this.activeGameData.size[0]) /
      this.activeGameData.gameResolution[0];
  };

  public getParent = (): PIXI.Container => {
    return this.parent;
  };

  public setActiveAnimationIndex = (index: number): void => {
    //index=0  animation In and index 1 animation out
    switch (index) {
      case 0:
        this.setStartAnimation(); //enter
        break;

      case 1:
        this.setEndAnimation(); //exit
        break;
      default:
        break;
    }
  };

  public checkAutoHideLabelOnMobileOrientationChange() {
    if (
      this.activeGameData.replay.isOpen() == false &&
      this.activeGameData.isMobile
    ) {
      let jackpotEnded = this.activeGameData.jackPotGame.getJackpotEnded();

      if (jackpotEnded && this.isPortraitMode) {
        this.setLabelContainerVisible(false);
      } else {
        this.setLabelContainerVisible(true);
      }
    }
  }
  public setLabelContainerVisible = (bool: boolean): void => {
    bool ? (this.labelsContainer.alpha = 1) : (this.labelsContainer.alpha = 0);
  };

  public setPortraitMode = (bool: boolean): void => {
    this.isPortraitMode = bool;
    this.checkAutoHideLabelOnMobileOrientationChange();
    if (bool) {
      this.labelsContainer.x = 125;
      this.labelsContainer.y = this.activeGameData.size[1] / 2 + 50;
      this.labelsContainer.scale.set(2.3);
      //customposition
      this.megaBox.setPosition(0, this.activeGameData.size[1] / 2 - 150);
      this.midiBox.setPosition(0, this.activeGameData.size[1] / 2);
      this.miniBox.setPosition(0, this.activeGameData.size[1] / 2 + 150);

      // console.log(this.isCentered)
      let newSize = 1.5;
      // let closeBtn=1;
      if (this.isCentered == false) {
        this.wheelContainer.x =
          -(
            this.activeGameData.size[0] * newSize -
            this.activeGameData.size[0]
          ) /
            2 -
          322;
        this.wheelContainer.y =
          -(
            this.activeGameData.size[1] * newSize -
            this.activeGameData.size[1]
          ) /
            2 +
          130;
        this.wheelContainer.scale.set(newSize);
        //-
        this.wheel.getWinScreen();
      } else {
        this.wheelContainer.x =
          -(
            this.activeGameData.size[0] * newSize -
            this.activeGameData.size[0]
          ) / 2;
        this.wheelContainer.y =
          -(
            this.activeGameData.size[1] * newSize -
            this.activeGameData.size[1]
          ) /
            2 +
          130;
        this.wheelContainer.scale.set(newSize);
      }
      this.jackpotBlackBG.y = -this.activeGameData.portraitPlayOffsetTop; // fill outsideaswell

      this.wheel
        .getWinScreen()
        .getCloseBtnContainer()
        .scale.set(2);
      this.wheel.getWinScreen().getCloseBtnContainer().y =
        -this.activeGameData.size[1] + 300;
      this.wheel.getWinScreen().getCloseBtnContainer().x =
        -this.activeGameData.size[0] / 2 - 30.5;
    } else {
      this.labelsContainer.x = 0;
      this.labelsContainer.y = 0;
      this.labelsContainer.scale.set(1);
      this.setLabelTodefaultPos();
      this.wheelContainer.x = 0;
      this.wheelContainer.y = 0;
      this.wheelContainer.scale.set(1);
      this.jackpotBlackBG.y = 0;
      this.wheel.getWinScreen().getCloseBtnContainer().y = 0;
      this.wheel.getWinScreen().getCloseBtnContainer().x = 0;
      this.wheel
        .getWinScreen()
        .getCloseBtnContainer()
        .scale.set(1);
    }
  };
}
